import React from 'react';
import styles from './BaseModal.module.css';
import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

class BaseModal extends React.Component {
    render() {
        let {
          onClose,
          show,
          hasHeader,
          modalTitle,
          hasFooter,
          cssClass,
          width,
          children
        } = this.props;

        if (show) {
            return (
                <div className={styles.modal} onClick={onClose}>
                  <div className={`${styles.modalContent} ${cssClass}`} onClick={e => e.stopPropagation()} style={{width}}>
                    {hasHeader &&
                    <div className={styles.modalHeader}>
                      <h4 className={styles.modalTitle}>{modalTitle}</h4>
                      <Icon path={mdiClose} size={1} style={{cursor: "pointer"}} onClick={this.props.onClose} />
                    </div>}
                    <div className={styles.modalBody}>
                      {children}
                    </div>
                    {hasFooter &&
                    <div className={styles.modalFooter}>
                      <button>Close</button>
                    </div>}
                  </div>
                </div>
            )
        }

        return null;
    }
}

BaseModal.defaultProps = {
  hasHeader: true,
  hasFooter: true,
  cssClass: '',
  width: 'auto',
  modalTitle: 'Modal Title',
  onClose: () => { console.log('default handler'); }
}

export default BaseModal
